import { useTerminalsState } from "@/States/Terminals";
import { useTrans } from "@/translations";

import { useContext, useEffect, useMemo, useState } from "react";

import { twMerge } from "tailwind-merge";
import { throttle } from "throttle-debounce";

import { ViewType } from "../../../constants";
import { RecyclingRateTrendContext } from "../../../context";
import { TARGET_PRESETS } from "../constants";

export const RecyclingTargetView: React.FC = () => {
  const { t } = useTrans();
  const { currentTerminal } = useTerminalsState();
  const { target, updateTarget, viewType } = useContext(
    RecyclingRateTrendContext,
  );

  const [localTarget, setLocalTarget] = useState(target);

  useEffect(() => {
    setLocalTarget(target);
  }, [target]);

  const throttledUpdateTarget = useMemo(
    () => throttle(300, updateTarget, { noLeading: true }),
    [updateTarget],
  );

  useEffect(
    () => () => throttledUpdateTarget.cancel(),
    [throttledUpdateTarget],
  );

  const onTargetRangeChange = (value: number) => {
    setLocalTarget(value);
    throttledUpdateTarget(value);
  };

  const setTarget = (value: number) => {
    setLocalTarget(value);
    throttledUpdateTarget.cancel();

    updateTarget(value);
  };

  return (
    <div className="border-grey2 border-t p-3">
      <div className="text-grey6 mb-[9px] text-[10.5px] font-bold tracking-[0.05] uppercase">
        {t("homePage:optionsRecyclingTargetTitle")}
      </div>
      <div className="flex items-baseline justify-between">
        <div className="flex items-baseline gap-[3.3px]">
          <span className="font-signifier text-[30px] leading-none text-[#2F5A22]">
            {localTarget}
          </span>
          <span className="text-grey6 text-[14px]">%</span>
        </div>
        {viewType === ViewType.BUILDING && (
          <span className="text-grey6 text-[11px]">
            {t("homePage:optionsRecyclingTargetBuilding", {
              buildingName: currentTerminal?.name,
            })}
          </span>
        )}
      </div>
      <input
        type="range"
        min={0}
        max={100}
        step={1}
        value={localTarget}
        onChange={(e) => onTargetRangeChange(+e.target.value)}
        className="accent-carrot-green mt-1.5 w-full cursor-pointer"
      />
      <div className="mt-1.5 flex gap-[4.95px]">
        {TARGET_PRESETS.map((preset) => (
          <button
            key={preset}
            onClick={() => setTarget(preset)}
            className={twMerge(
              "flex-1 cursor-pointer rounded-md border py-[3.3px] text-[16px]",
              preset === localTarget
                ? "border-carrot-green bg-carrot-green text-white"
                : "border-grey3 bg-white text-black",
            )}
          >
            {preset}%
          </button>
        ))}
      </div>
    </div>
  );
};
